/* RESPONSIBLE TEAM: team-frontend-tech */
import BlockSerializer from './block';

export default BlockSerializer.extend();
